import * as React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import router from "./App";
import { I18nextProvider } from "react-i18next";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
// import './index.css';
import 'react-loading-skeleton/dist/skeleton.css'
import "./App.css";
import "animate.css/animate.css";
// Load Bootstrap through the package entry so components that import from
// "bootstrap" (for example the QR checkout modal) share the same instance and
// data store. Loading the bundle path separately creates a second Bootstrap
// runtime, which can leave a modal backdrop behind during navigation.
import "bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'rsuite/dist/rsuite.min.css';
import { getLocalKey } from "./utils/commonfunction";
import enTranslation from "./Locales/en.json";
import jaTranslation from "./Locales/ja.json";
import hiTranslation from "./Locales/hi.json";
import neTranslation from "./Locales/ne.json";
import thTranslation from "./Locales/th.json";
import zhTranslation from "./Locales/zh.json";
import { configurePwa } from "./pwa";
import {
  getQrInitialLocale,
  isQrOrderRoute,
  QR_LANGUAGE_STORAGE_KEY,
} from "./modules/qrOrder/utils/qrLocale";

configurePwa();

const renderApp = () => {
  ReactDOM.createRoot(document.getElementById("root")).render(
    // <React.StrictMode>
      <Provider store={store}>
        <I18nextProvider i18n={i18n}>
          <RouterProvider router={router} />
          <div
            id="main-loader"
            className="main-loader"
            style={{ display: "none" }}
          >
            <div className="spinner-border text-light" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </I18nextProvider>
      </Provider>
    // </React.StrictMode>
  );
};

(async () => {
  const qrOrderRoute = isQrOrderRoute(window.location.pathname);
  const embeddedLanguage = new URLSearchParams(window.location.search).get("language");
  const qrLanguage = getQrInitialLocale(
    window.location.pathname,
    getLocalKey(QR_LANGUAGE_STORAGE_KEY),
    embeddedLanguage
  );

  await i18n.use(LanguageDetector).init({
    resources: {
      en: { translation: enTranslation },
      ja: { translation: jaTranslation },
      hi : {translation : hiTranslation} , 
      ne : {translation : neTranslation} , 
      th : {translation : thTranslation}, 
      zh : {translation : zhTranslation}
    },
    fallbackLng:'en', /** Default lang */
    ...(qrLanguage ? { lng: qrLanguage } : {}),
    ...(qrOrderRoute ? { detection: { caches: [] } } : {}),
  });
  if (!qrOrderRoute && !getLocalKey("system_language")) {
    await i18n.changeLanguage("en");
  }
  renderApp();
})();
